import { analytics } from '../firebase'
import { analyticsEventFactory } from './eventsFactory'

export enum SCREENS {
  ABOUT_RARUM = 'About Rarum',
}

/** @deprecated */
export const analyticsEvent = analyticsEventFactory(analytics)